/* global axios */
import ApiClient from '../ApiClient';

class ReplySuggestion extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  get(conversationId) {
    return axios.get(`${this.url}/${conversationId}/reply_suggestion`);
  }

  approve(conversationId, id) {
    return axios.post(`${this.url}/${conversationId}/reply_suggestion/approve`, { id });
  }

  reject(conversationId, id) {
    return axios.post(`${this.url}/${conversationId}/reply_suggestion/reject`, { id });
  }
}

export default new ReplySuggestion();
